<template>
  <div class="box">
    <div class="performance">
      <div class="hearder">
        <el-select
          v-model="valueCity"
          placeholder="请选择"
          @change="searchChange"
        >
          <el-option
            v-for="item in optionCity"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-date-picker
          v-model="valueTime"
          type="month"
          placeholder="选择日期"
          :picker-options="setDisabled"
          @change="searchChange"
          :clearable="false"
        >
        </el-date-picker>
      </div>
      <div class="formList">
        <div class="title">基础信息</div>
        <div class="field">
          <div class="label">单位</div>
          <div class="value">{{ infolist.unit ? infolist.unit : "--" }}</div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">提取比例</div>
          <div class="value">
            {{ infolist.extractionRatio ? infolist.extractionRatio : "--" }}
          </div>
        </div>
      </div>
      <div class="formList">
        <div class="title">{{ m }}月奖金发放情况</div>
        <div class="field">
          <div class="label">{{ m }}月销售收入目标(万元)</div>
          <div class="value">
            {{ infolist.salesTarget ? infolist.salesTarget : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">{{ m }}月销售收入完成值(万元)</div>
          <div class="value">
            {{
              infolist.salesCompletionValue
                ? infolist.salesCompletionValue
                : "--"
            }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">{{ m }}月销售目标完成率</div>
          <div class="value">
            {{
              infolist.salesTargetCompletionRate
                ? infolist.salesTargetCompletionRate
                : "--"
            }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">返利(万元)</div>
          <div class="value">
            {{ infolist.rebate ? infolist.rebate : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">剔除后收入完成值(万元)</div>
          <div class="value">
            {{ infolist.incomeValue ? infolist.incomeValue : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">{{ m }}月单月工资总额</div>
          <div class="value">
            {{ infolist.totalAmount ? infolist.totalAmount : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">1-{{ m }}月累计工资总额(万元)</div>
          <div class="value">
            {{
              infolist.accumulateTotalAmount
                ? infolist.accumulateTotalAmount
                : "--"
            }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">1-{{ m }}月固定工资</div>
          <div class="value">
            {{ infolist.fixedIncome ? infolist.fixedIncome : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label" v-if="m == 1">1-{{ m }}月已发奖金</div>
          <div class="label" v-if="m != 1">1-{{ delM }}月已发奖金</div>
          <div class="value">{{ infolist.bonus ? infolist.bonus : "--" }}</div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">核算奖金包(万元)</div>
          <div class="value">
            {{ infolist.calculateBonus ? infolist.calculateBonus : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">预留奖金包(万元)</div>
          <div class="value">
            {{ infolist.reservedBonus ? infolist.reservedBonus : "--" }}
          </div>
        </div>
        <div class="line"></div>
        <div class="field">
          <div class="label">应分配奖金包(万元)</div>
          <div class="value">
            {{ infolist.shouldBonus ? infolist.shouldBonus : "--" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/performance";
import { getToken } from "@/utils/cookie";
import apis from "@/apis";
export default {
  name: "performance",
  components: {},
  data() {
    return {
      valueCity: "",
      optionCity: [],
      valueTime: new Date(),
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 可选历史天、不可选将来天
        },
      },
      infolist: {},
    };
  },
  computed: {
    m() {
      return moment(this.valueTime).format("M");
    },
    delM() {
      return moment(this.valueTime).subtract(1, "M").format("M");
    },
  },
  mounted() {
    const { orderDate, list } = this.$route.query;
    console.log(orderDate, "orderDate");
    console.log(list, "list");
    if (orderDate) {
      this.valueTime = moment(orderDate).format("YYYY-MM");
    }
    //获取hrToken
    let token = getToken();
    if (token) {
      const userInfo = JSON.parse(localStorage.getItem("store")).userInfo;
      this.optionCity = userInfo.unitList;
      this.valueCity = this.optionCity[0];
      this.getList();
    } else {
      this.$bus.$on("processToken", (res) => {
        apis.queryByUsername({ username: res }).then((data) => {
          this.optionCity = data.data.unitList;
          this.valueCity = this.optionCity[0];
          this.getList();
        });
      });
    }
    // if (orderDate) {
    //   this.valueTime = moment(orderDate).format("YYYY-MM");
    //   this.optionCity = list.replace("[", "").replace("]", "").split(",");
    //   this.valueCity = this.optionCity[0];
    // } else {
    //   const userInfo = JSON.parse(localStorage.getItem("store")).userInfo;
    //   this.optionCity = userInfo.unitList;
    //   this.valueCity = this.optionCity[0];
    // }
  },
  methods: {
    searchChange() {
      this.getList();
    },
    //获取详情信息
    getList() {
      api
        .queryByPage({
          unit: this.valueCity.trim(),
          orderDate: moment(this.valueTime).format("YYYYMM"),
        })
        .then((res) => {
          console.log(res, "res");
          if (res.data.list.length > 0) {
            this.infolist = res.data.list[0];
          } else {
            this.infolist = {};
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .performance {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .performance {
    width: 276px * $zoom;
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.performance {
  font-size: 12px * $zoom;
  min-height: 100vh;
  background: #f7f9fa;
  position: relative;
  .hearder {
    height: 114px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 30px;
    ::v-deep {
      .el-input__inner {
        height: 67px;
        width: 180px;
      }
      .el-input--mini .el-input__icon {
        line-height: 65px;
      }
      .el-date-editor {
        width: 220px;
        margin-left: 30px;
        .el-input__inner {
          height: 67px;
          width: 220px;
        }
      }
    }
  }
  .formList {
    margin-top: 30px;
    background: #fff;
    padding: 30px 30px 10px;
    .title {
      font-size: 33px;
      font-weight: bold;
      color: #000;
      margin-bottom: 30px;
    }
    .field {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #666666;
      font-size: 29px;
      margin-bottom: 20px;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #f1f1f1;
      margin-bottom: 20px;
    }
  }
}
</style>
